import tw, { styled } from 'twin.macro'

const PageHeader = styled.h1([tw`mb-6 text-3xl`])

export default PageHeader
